import OrdersKPIs from "./order/OrderKPIs";

const HomePage = () => {
  

  return (
    <div className="max-w-6xl mx-auto mt-10 px-4">
      <OrdersKPIs/>

     
    </div>
  );
};

export default HomePage;
